import { z } from 'zod';

export const formFieldSchema = z.object({
  name: z.string().min(1).max(60),
  label: z.string().min(1).max(160),
  type: z
    .enum(['text', 'email', 'tel', 'phone', 'number', 'textarea', 'select', 'checkbox', 'radio', 'date', 'url', 'file', 'hidden'])
    .default('text'),
  required: z.boolean().default(false).optional(),
  placeholder: z.string().max(160).optional(),
  helper: z.string().max(300).optional(),
  default: z.union([z.string(), z.number(), z.boolean()]).optional(),
  width: z.enum(['full', 'half', 'third', 'two-thirds']).default('full').optional(),
  options: z
    .union([
      z.array(z.string().min(1).max(200)),
      z.array(z.object({ value: z.string(), label: z.string() })),
    ])
    .optional(),
  validation: z
    .object({
      min: z.number().optional(),
      max: z.number().optional(),
      pattern: z.string().max(200).optional(),
    })
    .optional(),
});

export const formSchema = z.object({
  eyebrow: z.string().max(80).optional(),
  title: z.string().max(200).optional(),
  subtitle: z.string().max(500).optional(),
  formKey: z.string().min(1).max(80),
  /** Si se rellena, sobreescribe el submitLabel del form configurado en admin. */
  submitLabel: z.string().min(1).max(80).optional(),
  /** Si se rellena, sobreescribe el mensaje de éxito del form. */
  successMessage: z.string().max(400).optional(),
  consent: z.string().max(400).optional(),
  /** Layout del formulario relativo al contenido. */
  layout: z.enum(['centered', 'split', 'inline']).default('centered').optional(),
  /** Variante visual del fondo. */
  variant: z.enum(['default', 'card', 'dark']).default('default').optional(),
  /**
   * Campos opcionales: si están presentes, se usan en vez de los configurados en admin
   * (modo retrocompatible). Si están vacíos, el render hace fetch a /public/forms/{key}.
   */
  fields: z.array(formFieldSchema).max(50).optional(),
});

export type FormBlockData = z.infer<typeof formSchema>;
export type FormFieldData = z.infer<typeof formFieldSchema>;
